var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"div",staticClass:"c-btn",class:[
        _vm.simple ? 'c-btn--simple' : '',
        _vm.bgColor ? ("bg-" + _vm.bgColor) : '',
        _vm.size ? ("c-btn--" + _vm.size) : '',
        _vm.disabled ? 'is-disabled' : ''
    ],on:{"click":function($event){$event.stopPropagation();return _vm.onClick($event)}}},[(_vm.iconBefore)?_c('Icon',{staticClass:"c-btn__icon",attrs:{"icon":_vm.iconBefore}}):_vm._e(),_c('span',{staticClass:"c-btn__label"},[_vm._t("default",[_vm._v(_vm._s(_vm.label))])],2),(_vm.iconAfter)?_c('Icon',{staticClass:"c-btn__icon",attrs:{"icon":_vm.iconAfter}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }